// Mock data for Ambrosia Foods website
export const mockData = {
  // Home page featured brands
  featuredBrands: [
    {
      id: 'blue-tokai',
      name: 'Blue Tokai',
      category: 'COFFEE AT ITS BEST',
      title: 'Brewing The Future of Artisanal Coffee',
      image: '/images/home_top_blue_tokai.png',
      carouselImages: [
        '/images/home_carousel_blue_tokai1.png',
        '/images/home_carousel_blue_tokai2.png',
        '/images/home_carousel_blue_tokai3.png'
      ],
      description: 'Blue Tokai is committed to quality and sustainability. Sourcing and roasting beans to perfection, bringing an elevated coffee experience to every cup.'
    },
    {
      id: 'furn-beano',
      name: 'Furn Beaino',
      category: 'LEBANESE AND BEYOND',
      title: 'Fast Casual Food For A Good Mood',
      image: '/images/home_top_furn_beano.png',
      carouselImages: [
        '/images/home_carousel_furn1.png',
        '/images/home_carousel_furn2.png',
        '/images/home_carousel_furn3.png'
      ],
      description: '  Established in 1975 during the onset of Lebanon’s civil war, Furn Beaino began as a small bakery in the old souks of Jounieh. At just 20 years old, Toni Beaino set out to launch a humble yet ambitious culinary venture built on unwavering dedication to quality and consistency.'
    },
    {
      id: 'biryani-by-kilo',
      name: 'Biryani by Kilo',
      category: 'MEET THE BIRYANI EXPERTS',
      title: 'Experience Fresh Dum-Cooked Biryani',
      image: '/images/home_top_bbk.png',
      carouselImages: [
        '/images/home_carousel_bbk1.png',
        '/images/home_carousel_bbk2.png',
        '/images/home_carousel_bbk3.png'
      ],
      description: 'Biryani by Kilo (BBK) is a renowned Indian biryani brand celebrated for its authentic, slow-cooked Dum-style biryani.'
    },
    {
      id: 'mr-brown',
      name: 'Mr. Brown',
      category: 'YOUR FRIENDLY NEXT-DOOR DINER',
      title: 'Your Friendly Next-Door Diner',
      image: '/images/home_top_brown.png',
      carouselImages: [
        '/images/home_carousel_brown1.jpg',
        '/images/home_carousel_brown2.jpg',
        '/images/home_carousel_brown3.jpg'
      ],
      description: '     Since opening its doors in Lebanon in 2002, Mr. Brown has grown into a beloved homegrown brand and a market leader in its category. Built on the spirit of the classic American diner, Mr. Brown blends hearty comfort food with a warm, neighborhood feel—serving everything from signature burgers, submarines, and pizzas to pancakes, fresh salads, and a dedicated healthy menu crafted for lighter, low-calorie choices.'
    }
  ],

  // About page content
  aboutUs: {
    heroTitle: 'Ambrosia is a major platform for bringing new brands to the GCC',
    heroImage: '/images/about_top_image.png',
    description: 'Ambrosia Foods is a dedicated platform for launching and growing innovative food brands across the GCC. We specialise in bringing high-quality, international brands to the region through partnerships with strong dining, delivery, and takeaway. Our focus is on building a portfolio of brands that cater to the evolving tastes and lifestyle needs of modern consumers in this region.',
    missionTitle: 'Our Mission',
    missionText: 'Our mission is simple: to bring the best of the world to the Middle East. We\'re committed to curating a diverse collection of brands that not only offer exceptional quality and flavour but also embrace a data-driven approach to dining. At Ambrosia Foods, we\'re shaping the future of food by delivering delicious experiences, one brand at a time.',
    approachTitle: 'Our Approach',
    approachText: 'We begin with bold food brands from India and around the world, helping them redefine how consumers engage with flavour and convenience. We invest strategically across a variety of operating formats, focusing on brands that align with evolving preferences and are poised for significant growth.',
    approachImage: 'https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHRlYW18ZW58MHx8fHwxNzU5MTg5NTA4fDA&ixlib=rb-4.1.0&q=85'
  },

  // Team members
  teamMembers: [
    {
      id: 1,
      name: 'Vishal Narain',
      image: 'https://images.unsplash.com/photo-1568992687947-868a62a9f521?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHRlYW18ZW58MHx8fHwxNzU5MTg5NTA4fDA&ixlib=rb-4.1.0&q=85',
      bio: 'Vishal brings over 12 years of experience in the hospitality industry with extensive experience across hotel and restaurant management. A Cornell alum, Vishal has worked with leading restaurant groups across Asia and the United States.'
    },
    {
      id: 2,
      name: 'Saurabh Rai',
      image: 'https://images.pexels.com/photos/8818667/pexels-photo-8818667.jpeg',
      bio: 'Saurabh has extensive experience in the restaurant business across Canada, the US and Asia Pacific. He has worked across multiple functions including business development, restaurant operations and project management.'
    },
    {
      id: 3,
      name: 'Rakesh Garhania',
      image: 'https://images.unsplash.com/photo-1752766074168-44afdbaaf390?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBkaW5pbmd8ZW58MHx8fHwxNzU5MjI1MTc4fDA&ixlib=rb-4.1.0&q=85',
      bio: 'Rakesh brings experience across industries and geographies. He has extensive experience working across strategy, business development and operations.'
    },
    {
      id: 4,
      name: 'Wisam',
      image: 'https://images.pexels.com/photos/34067037/pexels-photo-34067037.jpeg',
      bio: 'Wisam brings extensive experience in F&B operations in the Saudi and Lebanese markets. He has worked with leading food service companies and has significant experience in brand development.'
    }
  ],

  // Footer links
  footerLinks: {
    company: [
      { name: 'About', link: '/about' },
      { name: 'Our Brands', link: '/brands' },
      { name: 'Our Team', link: '/team' },
      { name: 'Partner With Us', link: '/partner' },
      { name: 'Press Coverage', link: '/press' }
    ],
    legal: [
      { name: 'Store Locations', link: '/locations' }
    ]
  }
};